import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { Shield, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function UsageMeter() {
  const { data: profile } = useQuery({
    queryKey: ["profile"],
    queryFn: () => api.getProfile()
  });

  const isPro = profile?.is_pro || false;
  const isFounder = profile?.user_mode === "founder";

  return (
    <div className="border-4 border-black p-6 bg-white space-y-4 font-mono text-xs select-none shadow-[4px_4px_0_0_#000]">
      <h4 className="font-black uppercase flex items-center gap-2 border-b border-black/10 pb-2">
        <Shield className="w-4 h-4 text-primary" /> Active Plan Coverage
      </h4>

      <div className="space-y-2">
        <div className="flex justify-between font-bold uppercase text-[10px]">
          <span>AI Outage Fixes</span>
          <span className="text-green-600 flex items-center gap-1"><Check className="w-3.5 h-3.5" /> Unlimited Active</span>
        </div>
        <p className="text-[9px] text-zinc-500 uppercase font-semibold">
          No limits. No credits. No 3am anxiety.
        </p>
      </div>

      {!isPro && !isFounder && (
        <div className="pt-2">
          <Link to="/pricing">
            <Button className="w-full rounded-none border-2 border-black bg-black text-white hover:bg-white hover:text-black font-black uppercase text-[9px] py-2">
              Upgrade to Lifetime Pro Deal ($499 Once) →
            </Button>
          </Link>
        </div>
      )}
    </div>
  );
}
